export const notificationStyles = {
  xs: {
    container: {
      width: 150,
      padding: "5px 10px"
    },
    time: {
      fontSize: "0.3rem !important"
    },
    label: {
      fontSize: "0.4rem !important"
    },
    icon: {
      fontSize: "12px"
    },
    title: {
      fontSize: "0.5rem !important"
    }
  },
  lg: {
    container: {
      width: 240,
      padding: "7px 14px"
    },
    time: {
      fontSize: "0.45rem !important"
    },
    label: {
      fontSize: "0.6rem !important"
    },
    icon: {
      fontSize: "15px"
    },
    title: {
      fontSize: "0.65rem !important"
    }
  },
  xl: {
    container: {
      width: 340,
      padding: "10px 20px"
    },
    time: {
      fontSize: "0.8rem !important"
    },
    label: {
      fontSize: "0.9rem !important"
    },
    icon: {
      fontSize: "20px"
    },
    title: {
      fontSize: "1rem !important"
    }
  }
}